export default {
  'home.top.title': 'Specialized unicorn investment transfer platform',
  'home.top.desc': 'Invest best in investing',
  'home.center.title1': 'Top Unicorn',
  'home.center.title2': 'Latest news',
  'home.center.title3': 'How to use',
  'home.center.valuation': 'Valuation',
  'home.help.title1': 'Join CTFEX',
  'home.help.title2': 'Invest Unicorn',
  'home.help.title3': 'Buyback and transfer',
  'home.help.desc1': 'Register now and join investing Unicorn club',
  'home.help.desc3': 'IPO or transfer',
  'home.unicorn.purchase': 'Subscribe now',
  'home.unicorn.transfer': 'Trade now',


  ////以下是新
  'account.plan.end.title': 'Close at',
  'account.plan.stock.name': 'IPO',
  'account.plan.action': 'Decision',
  'account.plan.stock.code': 'Stock',
  'account.plan.onhand.got.rate': 'Win Rate',
  'account.plan.sell.profit': 'Profit',
  'account.plan.avg.profit': 'Avg Profit',
  'account.plan.create.time': 'Since',
  'account.plan.currenct.asset': 'NAV',
  'account.plan.manager': ' Manager',
  'account.plan.action.now': 'IPO',
  'account.plan.weight.curve': 'Weighted Yield Curve',
  'account.plan.history': 'History',
  'asset.recharge.legal.notice': 'Ask service team for how to deposit fiat currency with your overseas bankcard.',
  'account.plan.notice': 'Notice',
  'account.plan.have.close': 'This plan is closed',

  'finance.page.title': 'Wealth Management',
  'finance.list.title1': 'Investment Advisory',
  'finance.list.title2': 'Funds',
  'finance.list1': 'AP China Selected',
  'finance.list2': 'Sunivers Investment Selected',
  'finance.list3': 'Meritswater Family Office',
  'finance.list.tip': 'Please complete professional investor verification and authorization. Kindly contact customer service team for details',
  'finance.table1': 'Price',
  'finance.table2': 'Time',
  'finance.modal1': 'After joining, you will participate in new IPO subscription with Plan and sell automatically on listing date. For independent decision, you can withdraw from this Plan after ',
  'finance.modal2': ' working days.',
  'finance.modal3': 'In order to make full use of your fund, this Plan requires net assets between ',
  'finance.modal4': '',
  'finance.modal5': 'Cannot withdraw from the plan within ',
  'finance.modal6': ' days after joining',
  'finance.modal7': 'This Plan requires assets between ',
  'finance.modal8': '',

  'header.nav10': 'Learn',
  'edu.tip': 'This information is educational and does not constitute tax or investment advice. This information is not a recommendation to buy, hold, or sell an investment or financial product. All investments involve risks. You should make investment decisions based on your preference and knowledge.',
  'edu.library': 'Library',
  'edu.update': ' Updated',
  'edu.author': 'WBroker',
  'edu.viewMore': 'Explore',
  'edu.question.title': 'Did this answer your question?',
  'edu.question.answer': ' of ',
  'edu.question.answer2': 'people said that this answered their question.',
  'edu.used': 'Yep!',
  'edu.unused': 'No!',
  'edu.deal.title': 'Ready to start investing?',
  'edu.deal.desc': 'Sign up for WBroker and get your first stock on us.',
  'edu.deal': 'Start investing',
  'edu.more.detail': 'More',

  'edu.register': 'Sign up',

  'finance.modal9': 'This Plan requires net assets over ',
  'finance.moda20': ' and cash balance over ',
  'finance.moda21': "You can't join this Plan if you have any IPO subscription order or new-issuing position",

  'account.plan.join.ok': 'Success!',
  'account.plan.join.fail.notice': "You can't join in this Plan before you withdraw from the previous Plan",
  'account.plan.join.message.fail': "You can't join the Plan with any pending order or position",
  'account.plan.can.not.quit.reason': 'You can withdraw from the Plan {entrustPlan.outConditionQuitTime} days after you join it',
  'account.plan.have.quit': 'You have withdrawn from this Plan',
  'account.plan.join.fail': 'Failed',
  'account.plan.join.other.fail': "You can't join in this Plan before you withdraw from the previous Plan",
  'account.plan.stock.pick': 'Yes',
  'account.plan.stock.nopick': 'No',

  'modal.common.ok.text2': 'OK',
  'modal.common.sure.text': 'OK',
  'modal.common.sure.text2': 'Confirm',
  'modal.common.cancel.text': 'Cancel',
  'modal.common.quit.text1': 'Stay',
  'modal.common.quit.text2': 'Leave',

  'account.plan.join.ask': 'Confirm to join this Plan?',
  'account.plan.quit.ask': 'Confirm to quit from this Plan?',

  'account.plan.out.other.fail': "You can't withdraw from this Plan if you have any order or position. ",
  'account.plan.out.part.fail': "You can't withdraw from this Plan if you have any IPO subscription order or new-issuing position. ",


  'form.user.set.validate.input.mobile.is.ok': 'Incorrect mobile number',
  'form.user.set.validate.input.mobile': 'Enter mobile number',
  'form.user.set.validate.input.email': 'Enter email',
  'form.user.set.validate.input.email.is.ok': 'Incorrect email',
  'form.user.set.prefix.password': 'Login password',
  'form.user.set.prefix.txpassword': 'Transaction PIN',
  'form.user.set.validate.encryptPwd.is.ok': 'Incorrect format',
  'form.user.set.prefix.origin.password': 'Old code',
  'form.user.set.prefix.origin.txpassword': 'Old Pwd',

  'form.placeholder.input.new.mobile': 'New mobile number',
  'form.user.login.prefix.new.email': 'New email',

  'form.safe.invest.prefix.major.income': 'Your primary income is',
  'form.safe.invest.major.income.A': 'Salary',
  'form.safe.invest.major.income.B': 'Business income',
  'form.safe.invest.major.income.C': 'Income from financial asset',
  'form.safe.invest.major.income.D': 'Income from real estate',
  'form.safe.invest.major.income.E': 'No fixed income',

  'form.safe.invest.prefix.house.income': 'Your household disposable annual income is',
  'form.safe.invest.house.income.A': '< 0.2m',
  'form.safe.invest.house.income.B': '0.2~1m',
  'form.safe.invest.house.income.C': '1~5m',
  'form.safe.invest.house.income.D': '5~10m',
  'form.safe.invest.house.income.E': '> 10m',

  'form.safe.invest.prefix.financial.invest': 'How many percentage of disposable annual income can you use for financial investment?',
  'form.safe.invest.financial.invest.A': '< 10%',
  'form.safe.invest.financial.invest.B': '10%~25%',
  'form.safe.invest.financial.invest.C': '25%~50%',
  'form.safe.invest.financial.invest.D': '> 50%',

  'form.safe.invest.prefix.debt': 'Do you have massive outstanding debts?',
  'form.safe.invest.debt.A': 'No',
  'form.safe.invest.debt.B': 'Yes, long-term fixed debt like housing mortgage',
  'form.safe.invest.debt.C': 'Yes, short-term credit debt like credit card debt',
  'form.safe.invest.debt.D': 'Yes, borrowing from relatives and friends',

  'form.safe.invest.prefix.investment.knowledge': 'How much do you know about investment?',
  'form.safe.invest.investment.knowledge.A': 'I have no idea about investment',
  'form.safe.invest.investment.knowledge.B': 'I know a thing or two about investment',
  'form.safe.invest.investment.knowledge.C': 'I am a pro.',

  'form.safe.invest.prefix.investment.experience.desc': 'How to describe your investment experience?',
  'form.safe.invest.investment.experience.desc.A': 'I have no investment experience except bank deposit',
  'form.safe.invest.investment.experience.desc.B': 'I bought financial products such as bonds and insurance',
  'form.safe.invest.investment.experience.desc.C': 'I traded stocks, funds, and other products',
  'form.safe.invest.investment.experience.desc.D': 'I traded warrants, futures, options, and other products',

  'form.safe.invest.prefix.investment.experience': 'How many years of experience do you have in investing funds, stocks, trusts, private equity securities, or financial derivatives?',
  'form.safe.invest.investment.experience.A': 'None',
  'form.safe.invest.investment.experience.B': '< 2 years',
  'form.safe.invest.investment.experience.C': '2~5 years',
  'form.safe.invest.investment.experience.D': '5~10 years',
  'form.safe.invest.investment.experience.E': '> 10 years',

  'form.safe.invest.prefix.investment.horizon': 'What is your investment time horizon?',
  'form.safe.invest.investment.horizon.A': '< 1 year',
  'form.safe.invest.investment.horizon.B': '1~3 year',
  'form.safe.invest.investment.horizon.C': '3~5 year',
  'form.safe.invest.investment.horizon.D': '> 5 year',

  'form.safe.invest.prefix.investment.varieties': 'Which investment do you prefer?',
  'form.safe.invest.investment.varieties.A': 'Bonds, money market funds, bond funds, and other fixed income investments',
  'form.safe.invest.investment.varieties.B': 'Stocks, hybrid funds, equity funds,, and other equity investments',
  'form.safe.invest.investment.varieties.C': 'Futures, options, and other financial derivatives',
  'form.safe.invest.investment.varieties.D': 'Other',

  'form.safe.invest.prefix.investment.attitude': 'Which best describes your investment preference?',
  'form.safe.invest.investment.attitude.A': 'Risk averse. I hate to lose my principal and hope for stable returns',
  'form.safe.invest.investment.attitude.B': 'Conservative. I do not want to lose my principal but I  accept reasonable fluctuation',
  'form.safe.invest.investment.attitude.C': 'I seek high returns and I am willing to bear limited principal loss',
  'form.safe.invest.investment.attitude.D': 'I like high returns and I am willing to bear large principal loss',

  'form.safe.invest.prefix.investment.question': 'Suppose there are two types of investment: A is expected to obtain 10% return, and the possible loss is very small; Investment B is expected to obtain 30% return, but possible loss is bigger; You would invest',
  'form.safe.invest.investment.question.A': 'All in A',
  'form.safe.invest.investment.question.B': 'In both, but most in A',
  'form.safe.invest.investment.question.C': 'In both, but most in B',
  'form.safe.invest.investment.question.D': 'All in B',

  'form.safe.invest.prefix.biggest.loss': 'What is the maximum possible loss you could afford?',
  'form.safe.invest.biggest.loss.A': '< 10%',
  'form.safe.invest.biggest.loss.B': '10%~30%',
  'form.safe.invest.biggest.loss.C': '30%~50%',
  'form.safe.invest.biggest.loss.D': '> 50%',

  'form.user.safe.investor.btn.submit': 'Submit',

  'form.user.safe.investor.validation.error': 'Investors selecting this option are not able to invest on WBroker.',

  'form.user.safe.name.prefix.card.type': 'ID type',
  'form.user.safe.name.prefix.real.name': 'Name',
  'form.user.safe.name.prefix.card.number': 'ID No.',
  'form.user.safe.name.placeholder.input.id': 'Enter ID number',
  'form.user.safe.name.placeholder.input.name': 'Enter real name',
  'form.user.safe.name.idcard': 'ID card',
  'form.user.safe.name.passport': 'Passport',
  'form.user.safe.name.passport.other': 'other',
  'form.user.safe.name.driver': 'Driving License',

  'form.user.safe.name.validate.input.name': 'Enter real name',
  'form.user.safe.name.validate.input.idcard.is.ok': 'Enter ID number',

  'form.account.name.prefix.idcard': 'ID No.',
  'form.account.name.prefix.expiry.date': 'Exp. date',
  'form.account.name.placeholder.input.expiry.date': 'Enter expiry date (1990-01-01)',
  'form.account.name.prefix.address': 'Address',
  'form.account.name.placeholder.input.address': 'Enter address',
  'form.account.name.prefix.issue.address': 'ID Add.',
  'form.account.name.placeholder.input.issue.address': 'Enter ID address',
  'form.account.name.validate.idcard.error': 'Wrong ID No.',
  'form.account.name.validate.date.error': 'Incorrect expiry date (1990-01-01)',
  'form.account.name.validate.input.address': 'Enter address',
  'form.account.name.prefix.address.prove': 'Address proof (e.g. utility bill/bank statement)',
  'form.upload.text': 'Upload',
  'form.upload.picture.to.max': 'Incorrect size',
  'form.account.name.upload.click.front': 'Image Side',
  'form.account.name.upload.click.back': 'Emblem Side',
  'form.account.name.upload.click.hold': 'Upload handhold image',
  'form.account.name.card.example': 'Click to see demonstration',
  'form.account.name.prefix.show.address': 'Address matches ID',
  'form.account.name.upload.click.info': 'Image Page',
  'form.account.name.upload.click.info.back': 'Cover',
  'form.account.name.upload.click.info.hand': 'Upload handhold image',
  'form.account.name.prefix.card.number': 'ID No.',
  'form.user.login.validate.input.expiry.date': 'Enter expiry date',
  'form.account.name.placeholder.input.card.expiry.date': 'Format (YYYYMMDD-YYYYMMDD)',
  'form.account.name.validate.upload.address': 'Upload ID proof',

  'form.account.name.upload.click.face': 'Face recognition',

  'form.account.last.step': 'Back',
  'form.account.type': 'ID Type',
  'form.account.type1': 'China Mainland',
  'form.account.type2': 'HK',
  'form.account.ocr.fail': 'ID OCR failed, please upload again',
  'form.account.phone.tip': 'Camera Tips',
  'form.account.version.old': 'Please download the latest version from official website to open an account',
  'form.account.goto.download': 'Download',
  'form.account.open.type': 'Certificate',
  'form.account.open.ocr': 'OCR identifying ID',
  'form.account.open.face': 'Face processing',
  'form.account.click.cam': 'Click camera icon to recognize face',
  'form.account.face.again': 'Failed to upload face recognition information, please try again or contact CS for help',
  'form.account.face': 'Face recognition',
  'form.account.click.upload': 'Upload residential address proof',
  'form.account.address.approve': 'Upload residential address proof',
  'form.account.house.has': 'Own',
  'form.account.house.use': 'Rent',
  'form.account.house.with': 'Live with relatives',
  'form.account.stepGrray1': '< 1 yr',
  'form.account.stepGrray2': '1~3 yrs',
  'form.account.stepGrray3': '3~10 yrs',
  'form.account.stepGrray4': '> 10 yrs',
  'form.account.stepGrrayChildren1': 'Stocks, bonds, and other securities',
  'form.account.stepGrrayChildren2': 'Leveraged foreign exchange',
  'form.account.stepGrrayChildren3': 'Precious metals',
  'form.account.stepGrrayChildren4': 'Futures/Options',
  'form.account.stepHrray1': 'Familiar',
  'form.account.stepHrray2': 'Not familiar',
  'form.account.stepHrrayChildren1': 'trading derivatives',
  'form.account.stepHrrayChildren2': 'taking lessons or training about derivatives',
  'form.account.stepHrrayChildren3': 'related working experience',
  'form.account.choose.houseStatus': 'Please complete the information',
  'form.account.houseStatus.value': 'Enter estimates',
  'form.account.houseStatus.number': 'Please enter value',
  'form.account.work.status': 'Please complete the employment information',
  'form.account.input.work.status': 'Please complete the employment information',
  'form.account.choose.edu': 'Please complete the education information',
  'form.account.choose.asset': 'Please complete the asset information',
  'form.account.choose.income': 'Please complete the income information',
  'form.account.choose.target': 'Please complete the investment information',
  'form.account.choose.experience': 'Please complete the experience information',
  'form.account.choose.experienceType': 'Please complete the experience information',
  'form.account.choose.derivativesKnowledge': 'Please complete the derivatives information',
  'form.account.choose.hasKnowledge': 'Please complete the derivatives information',
  'form.account.choose.riskTolerance': 'If your risk tolerance does not meet regulatory requirements, you will not be able to open account',
  'form.account.houseSituation': 'Housing',
  'form.account.valuation': 'Valuation (net of mortgage)',
  'form.account.valuation.placeholder': 'Enter amount',
  'form.account.work.label1': 'Employed by',
  'form.account.work.label1.placeholder': 'Enter your company name',
  'form.account.work.label2': 'Industry',
  'form.account.work.label2.placeholder': 'Enter the industry',
  'form.account.work.label3': 'Working for',
  'form.account.work.label3.placeholder': 'Enter years',
  'form.account.work.label4': 'Job',
  'form.account.work.label4.placeholder': 'Enter your job',
  'form.account.work.label5': 'Business type',
  'form.account.work.label5.placeholder': 'Enter the business type',
  'form.account.investmentExperience': 'Investment experience',
  'form.account.derivativesKnowledge': 'About derivatives',
  'form.account.derivativesKnowledge0': 'From',
  'form.account.risk': 'Risk Disclosure',
  'form.account.risk.standar': 'Licensed representative: ',
  'form.account.result.copy': 'Confirm and copy Wechat',
  'form.account.sign.upload.fail': 'Failed to upload signature, try again',
  'form.account.sign.reset': 'Eraser',

  'form.placeholder.input.password.new': '8-12 digit, letters+numbers+symbols',
  'form.placeholder.input.password.rule': 'Password (8-12 digit, letters+numbers+symbols)',

  'menu.account.name': 'ID verification ',
  'menu.account.add': 'Additional Information',

  'v3.menu.plan': 'Finance',
  'v3.menu.plan.detail': 'Detail',

  'menu.education.detail': 'Learn',

  'account.real.name.explain.first': '1. Under relevant regulations, you are required to fill in necessary information. You can start investing after passing investor assessment.',
  'account.real.name.explain.two': '2. You need to consider your investment goal and risk tolerance before investing in financial products with potential risk.',
  'account.name.example.title': 'Clear, full, and non-reflecting photo',
  'account.name.example.correct.dec': 'Example',
  'account.name.example.incomplete.dec': 'Incomplete',
  'account.name.example.vague.dec': 'Blurry',
  'account.name.example.reflective.light.dec': 'Reflective',
  'account.name.example.know': 'Confirmed',
  'account.name.result.title': 'Success!',
  'account.login.ok': 'Login Success!',

  'account.open.notice.upload.face': 'Front photo',
  'account.open.notice.upload.back': 'Back photo',
  'account.open.notice.upload.hand': 'Hand-hold photo',
  'account.open.notice.upload.all': 'Upload all photo',
  'account.open.notice.can.not.openaccount': 'You cannot open account with your current risk tolerance.',
  'account.open.form.title.choose': 'Please click all checkboxes',
  'account.open.form.work.status': 'Employment status',
  'account.open.form.work.hire': 'Employee',
  'account.open.form.work.hire.self': 'Self-employed',
  'account.open.form.work.other': 'Other',
  'account.open.education.status': 'Education',
  'account.open.education.status.primary': 'Primary or below',
  'account.open.education.status.middle': 'Middle school',
  'account.open.education.status.college': 'Junior college',
  'account.open.education.status.undergraduate': 'Bachelor or above',
  'account.open.asset.status': 'Personal assets',
  'account.open.asset.status30': '< 0.3m',
  'account.open.asset.status100': '0.3m~1m',
  'account.open.asset.status500': '1m~5m',
  'account.open.asset.status.more': '> 5m',
  'account.open.asset.year.status': 'Annual income',
  'account.open.asset.year.status10': '< 0.1m',
  'account.open.asset.year.status30': '0.1m~0.3m',
  'account.open.asset.year.status500': '0.3m~5m',
  'account.open.asset.year.status.more': '> 5m',
  'account.open.invest.target': 'Investment goal',
  'account.open.invest.target.no.lose': 'Breakeven',
  'account.open.invest.target.share': 'Dividend',
  'account.open.invest.target.all': 'Speculation',
  'account.open.invest.experience': 'Investment experience',
  'account.open.invest.experience.no': 'No',
  'account.open.invest.experience.soso': 'Average',
  'account.open.invest.experience.much': 'Rich',
  'account.open.affordability.status': 'Risk tolerance',
  'account.open.taffordability.status.no': 'Zero',
  'account.open.taffordability.status.low': 'Low (5~10% loss)',
  'account.open.taffordability.status.mid': 'Middle (10~20% loss)',
  'account.open.taffordability.status.high': 'High (20%+ loss)',
  'account.open.notice1': ' 1. Under relevant regulations, you are required to fill in necessary information. You can start investing after passing investor assessment.',
  'account.open.notice2': '2. You need to consider your investment goal and risk tolerance before investing in financial products with potential risk.',
  'account.open.quit.message': 'Confirm to leave from account opening?',
  'account.open.quit.message.present': 'Confirm to leave from account opening?',
  'account.open.vedio.not.support': 'Sorry, your browser does not support this video play.',
  'account.open.vedio.notice': ' Risk warning: All investments involve risks, including the possible loss of capital. Historical results cannot guarantee future performance or returns. Although diversification protects investment portfolios by reducing exposure to risks, it does not ensure you investment returns or prevent you from loss when the market is down. Stock trading entails risks and is not appropriate for all investors. You need to consider your investment goal and risk tolerance before investing.',
  'account.open.agrement.check': 'Read and agree to',
  'account.open.agrement.check.customer.file': '<Client Service Agreement>',
  'account.open.agrement.check.risk': '<Risk Disclosure>',
  'account.open.agrement.check.no.usa': '<W-8Ben Tax exemption form for non-Americans>',
  'account.open.agrement.check.commitment': '<Letter of Commitment>',
  'account.open.agrement.check1': 'I am the ultimate and sole beneficiary of this account.',
  'account.open.agrement.check2': 'I have no relationship with the directors and employees of this company.',
  'account.open.agrement.check3': 'I am not a licensee, employee, director, or executive of any exchange, security company, or other financial institution.',
  'account.open.agrement.check4': 'I do not serve as any important public office, such as officer in government agencies, military, or state-owned institutions.',
  'account.open.agrement.check5': 'I am not a U.S. permanent resident (green card holder)',
  'account.open.end.jump': 'Account has been opened. Jump to homepage in 3 seconds',
  'account.open.need.mobile': 'Please link to your mobile',
  'account.open.need.email': 'Please link to your email',

  'account.open.end.notice1': 'Your application has been submitted.',
  'account.open.end.notice2': 'It will be reviewed and processed within 1 hour.',
  'account.open.end.notice3': 'Add customer service Wechat:',
  'account.open.end.notice4': 'for a limited gift package worth 5,000 CNY',
  'account.open.end.notice5': 'Wish you good luck!',
  'account.open.end.notice': 'Your application has been submitted. It will be reviewed and processed within 1 hour.',
  'account.open.end.checking': 'Verifying',
  'account.open.no.liveFace': 'No face is recognized, please try again',
  'account.open.upload.img.fail': 'Failed to upload, please try again',
  'account.open.has.idNumber': 'The ID is already in use',
  'account.open.finish.info': 'Complete the information',
  'account.open.upload.img': 'Upload picture',
  'account.open.face.live': 'Face recognition',
  'account.open.ocr.finished': 'OCR recognized',
  'account.open.comparing': 'Match ID with face',
  'account.open.compare.approve': 'Matched!',
  'account.open.compare.fail': "ID didn't matched the face, please try again",
  'account.open.check.approve': 'Verified by the Ministry of Public Security',
  'account.open.check.fail': 'Not verified by the Ministry of Public Security',
  'account.open.check.api.fail': 'Verification failed, please try again',
  'account.open.ocr.fail': 'Unstable network, please upload again',
  'account.open.lining.police': 'Connecting to the Ministry of Public Security to verify the authenticity of the certificate',

  'account.open.phone.code.fail': 'Incorrect SMS verification code',
  'account.open.set.password.success': 'Login password is set',
  'account.open.bind.phone.success': 'Success!',
  'account.open.bind.email.success': 'Success!',
  'account.open.set.password.fail': 'Failed to set login password, please try again',
  'account.open.bind.phone.fail': 'Not linked to the mobile, please try again',
  'account.open.bind.email.fail': 'Not linked to the email, please try again',
  'account.open.bind.success': 'Success!',

  'account.open.sign.title': 'Signature',
  'account.open.sign.desc': 'Make sure the signature matches the name of account holder.',
  'account.open.sign.reset': 'Eraser',
  'account.open.sign.confirm': 'Confirm',
  'account.open.sign.alert': 'Please complete the signature',

  'v3.menu.share.open.title': 'Open Account',
  'v3.menu.share.open.verify': 'Open Account',
  'v3.menu.share.open.add.info': 'Open Account',
  'quotation.open.account': 'Open Account',
  'quotation.margin.account': 'Upgrade Account',
  'menu.user.safe.setting': 'Next',
  'message.mail.bind-by-other': 'The email is already in use!',
  'message.code.error': 'Incorrect confirmation code!',
  'form.suffix.get.verify.code': 'Send',

  'message.login.send.success': 'The confirmation code has been sent',

  'asset.account.open.wait.notice': 'Notice',

  'form.account.address.title': 'Select country/region',
  'form.placeholder.input.password': '8-12 digit',
  'form.choose.address': 'Select calling code',
  'form.search.address': 'Select country/region/calling code',
  'form.search.input': 'Search',

  'account.plan.join': 'Join',

  'menu.knight.rule': 'Knight Rules',

  'menu.user.safe.update.next': 'Next',

  'menu.notification.detail': 'Detail',

  'menu.help.detail': 'Help',
  'help.resolve.problem': 'Did this answer your question?',
  'help.resolve.problem.yes': 'Yes!',
  'help.resolve.problem.no': 'Nope！',
  'help.relate.title': 'Related Articles',
  'help.answer.noUse1': 'It is not helping? Contact ',
  'help.answer.noUse2': 'customer service',
  'help.answer.noUse3': ' ',
  //仍有疑问吗？联系${在线客服}

  'form.account.type9': 'Identity Certificate',
  'form.account.type4': 'Driving License',
  'form.stock.hk': 'HK STOCK',
  'form.stock.us': 'US STOCK',
  'form.stock.zht': 'CHINA CONNECT',
  'form.stock.aex': 'CRYPTO',
  'form.account.openMarket.title': 'I open account to trade',
  'account.open.agrement.aex.risk': '<Risk Disclosure of Cryptocurrency>',
  'account.open.agrement.laundering': '<User Guideline of Anti-Money Laundering>',
  'account.open.setPsw.title': 'Set initial transaction PIN',
  'account.open.setPsw.title.confirm': 'Confirm your transaction PIN',
  'account.open.setPsw.tip': 'Enter a six-digit number',
  'account.open.setPsw.error': "Those passwords didn't match. Try again",
  'account.open.setPsw.bottom.tip': '*Please remember your transaction PIN. To ensure the safety of assets, you are required to enter the PIN before each subsequent trade.',

  'account.open.market.tip1': 'It is required to authorize ',
  'account.open.market.tip2': ' trading service.',
  //账户需默认开通${港股}市场

  'help.thanks.feedBack': 'Thanks for your feedback!',
  'component.result.back': 'Back',


  'account.open.agrement.check.hkLetter.file': '<Hong Kong Investor Identification Regime (HKIDR) Individual Client Consents>',

  'menu.pi.title': 'Professional Investor Assessment',
  'pi.Title1': "Who's eligible as professional investor？",
  'pi.Title1.desc': 'According to "Securities and Futures (Professional Investor) Rules", individual investors with a portfolio ≥ HKD 8 million (or currency equivalent) in the last 12 months, or a portfolio ≥ HKD 8 million (or currency equivalent) or total assets ≥ HKD 40 million ( or equivalent currency) of any corporation/partnership, trust corporation with entrust of total assets of not less than 40 million HKD (or equivalent currency), and other professional corporations that meet the requirements have to be certified and approved to be regarded as a professional investor. ',
  'pi.Title2': 'How to be certified as professional investor?',
  'pi.chooseItem1': '1: Hold assets of more than HKD 8 million in WBroker',
  'pi.chooseItem2': '2: Submit asset proof with an equivalent value of more than 8 million HKD ',
  'pi.chooseItem3': 'asset certification',
  //方式二：提交持有等值800万港币以上资产${资产证明}
  'pi.modal.title': 'Requirements assets proof',
  'pi.modal.tip1': 'Valid asset types: cash, bank deposits and securities (stocks, funds, bonds, etc.).',
  'pi.modal.tip2': 'Note: Certificate of fixed assets such as real estate, properties shall not be regarded as a valid certificate for now.',
  'pi.btn.text': 'Assess',
  'pi.risk.desc1': 'Please read the following carefully about the risks of being a professional investor:',
  'pi.risk.desc2': '1. After applying to become a professional investor, WBroker can provide you with more investment products. However, such investment products may not be authorized by the Hong Kong Securities and Futures Commission and are not regulated by the Hong Kong Securities and Futures Commission, so your investment in such products will carry certain risks. It is recommended that you seek professional advice from an independent third party before applying.',
  'pi.risk.desc3': '2. After you apply to become a professional investor, WBroker is exempt from the following obligations:',
  'pi.risk.desc4': 'i. Provide information on the identity and employment status of WBroker employees and other representatives of WBroker',
  'pi.risk.desc5': 'ii. Confirm with you the important information of the transaction.',
  'pi.risk.desc6': 'iii. Provide you with information documents required by The Stock Exchange of Hong Kong Limited regarding the Nasdaq-American Stock Exchange Pilot Program.',
  'pi.risk.desc7': 'iv. Provide you with any closing documents, account statements or receipts as required by the Securities and Futures (Contract Notes, Account Statements and Receipts) Rules. Please note that it is not the case that WBroker will cease to perform these obligations, but WBroker reserves the right to waive these actions .',
  'pi.risk.desc8': '3. You should inform WBroker immediately if you are no longer qualified as a professional investor. You have the right to cancel your status as professional investor with WBroker',
  'pi.statement.title': 'Disclaimer',
  'pi.statement.desc1': ' I confirm that I hold an investment portfolio of not less than 8 million HKD (or its equivalent in currency). (Portfolio refers to cash, deposits and securities as defined in the Securities and Futures Ordinance) ',
  'pi.statement.desc2': 'I hereby declare as professional investors that WBroker will be exempt from certain requirements of the Code of Conduct and other relevant Hong Kong regulations. Although WBroker may in fact make some or all of the actions described below, WBroker is exempt from the following obligations. ',
  'pi.statement.desc3': '1.Provide information about the identity and employment status of its employees and other representatives of WBroker.',
  'pi.statement.desc4': '2.Confirm important points of the transaction',
  'pi.statement.desc5': '3.Provide information documents as prescribed by The Stock Exchange of Hong Kong Limited regarding the Nasdaq-US Stock Exchange Pilot Program.',
  'pi.statement.desc6': '4.Provide any closing documents, account statements or receipts as required by the Securities and Futures (Contract Notes, Account Statements and Receipts) Rules.',
  'pi.statement.desc7': ' I hereby confirm that ',
  'pi.statement.desc8': '1. Information provided in this evaluation and declaration form is accurate.',
  'pi.statement.desc9': '2. I am fully aware of the risks and consequences of being defined as a professional investor.',
  'pi.statement.desc10': '3. I understand that submitting this assessment form does not equate to approval as a professional investor.',
  'pi.statement.desc11': '4. WBroker may refuse to approve me as a professional investor without providing any reason.',
  'pi.statement.desc12': '5. I must inform WBroker immediately if I no longer qualify as a professional investor under the Securities and Futures (Professional Investor) Rules.',
  'pi.statement.desc13': '6. I am advised to ask questions and seek independent third-party advice if needed.',
  'pi.asset.imgUpload.toast': ' Upload proof',
  'pi.authStatus.reAuth': 'Assess again',
  'pi.authStatus.CERTIFIED': 'Passed',
  'pi.authStatus.REVIEW': 'Under Review',
  'pi.auth.liveFace': 'Please pass facial recognition',
  'pi.auth.liveFace.fail': 'Face recognition failed, please try again',
  'pi.auth.upload.title': 'Upload proof of asset',
  'pi.auth.upload.desc1': ' Types of valid assets: Account statements and certificates of cash, bank deposits and securities (stocks, funds, bonds, etc.) within 12 months.',
  'pi.auth.upload.desc2': 'Note: Proof of fixed assets, such as real estate properties, are not recorded as valid proof for now.',
  'pi.auth.asset.desc1': 'Your total net asset at WBroker is converted to ',
  'pi.auth.asset.desc2': ' HKD. To avoid any shortage of assets due to market fluctuations, please ensure that your net asset is sufficient.',
  //您在WBroker的净资产合计折算为XXX港币，避免市场波动导致的资产不足，请保证净资产的充余。
  'pi.auth.asset1': 'WBroker net assest ',
  'pi.auth.asset2': ' HKD',
  //WBroker净资产XXX港币
  'pi.auth.btn': 'Verify now',
  'pi.auth.result.tip': 'Your verification information has been submitted for review and it is expected to take 1-2 working days',
  'pi.auth.not.approve.reason': 'Reason: ',

  'stock.approving': 'Your application is under review.',

  'menu.active.rule': 'Rules',


  'menu.name.zh': 'Name',
  'menu.name.zh.placeholder': 'Please enter full name',
  'menu.name.zh.first': 'Surname',
  'menu.name.zh.first.placeholder': 'Example: Cheung',
  'menu.name.zh.second': 'First name (English)',
  'menu.name.zh.second.placeholder': 'Example: John',
  'user.cancel': 'Cancel',
  'user.ok': 'Confirm',
  'user.year': ' ',
  'user.month': ' ',
  'user.date': ' ',
  'user.country': 'Nationality',
  'user.tax.country': 'Region of tax return',
  'user.birthday': 'Date of birth',
  'user.birthday.placeholder': 'Please select date of birth',
  'user.date.choose': 'Please choose a date',
  'user.experied.date': 'Expiration date',
  'user.experied.placeholder': 'Expiration date',
  'user.experied.long.term': 'Valid in long term',
  'user.forth.tip1': 'When you click the ',
  'user.forth.tip2': "'I have read'",
  'user.forth.tip3': ' button, it means you have read and understood the risks described above',
  //当您点击${“已阅读”}按钮，表示您已阅读并了解上述风险
  'user.forth.btn': 'I have read',

  'menu.name.zh.first.other': 'Surname',
  'menu.name.zh.second.other': 'First name (English)',

  'open.account.file.title': 'Contract Signing',
  'open.account.file.desc': 'I have carefully read and agreed to sign all of the following account opening documents',
  'open.account.file.title2': 'Personal Statement',

  'user.getVerifyCodeFirst': 'Send verification code',

  'menu.updateInfo': 'Account Update',
  'update.info.idcard': 'ID Type',
  'update.face.now': 'Face recognition',
  'update.result.text': 'Your account update information has been submitted and is expected to be approved within 1-2 hours.',
  'update.result.tip1': 'For help, please contact ',
  'update.result.tip2': 'customer service',
  'update.result.tip3': '',
  'menu.name.zh.cn': 'Name(CN)',

  'menu.trs.title': 'TRS Certification',
  'tres.error.message940104': 'You can not open TRS account for the reason: did not pass PI verification.',
  'tres.error.message940103': 'You can not open TRS account for the reason: holding non-HK assets/liabilities.',
  'tres.error.message44444': 'You can not open TRS account for the reason: incorrect current status.',
  'tres.error.message12': 'Wrong PIN.',
  'trs.first.title1': 'Please prepare the following items: ',
  'trs.first.prepare1': '1. Photo of Passport or HK/Macao Travel Permit within validity.',
  'trs.first.prepare2': '2. Proof of Address for the last 3 months.',
  'trs.first.prepare3': '3. Account Statement (original asset proof) with a portfolio of not less than 8 million HKD or equivalent foreign currency for the last 12 months.',
  'catch.error': 'Request timeout or network exception, please try again later.',
  'trs.first.title2': 'Please select document region',
  'trs.first.address.label': 'Document Region',
  'trs.first.title3': 'Please select document type',
  'trs.first.passport': 'Passport',
  'trs.first.Permit': 'HK/Macao Travel Permit',
  'trs.first.save.code': 'Save code',
  'trs.first.contact.wachat': 'If you have any questions, Add weChat: TRS service advisor ',
  'trs.first.mobile': 'Tel：',
  'trs.second.finish.pic': 'Please complete the image information.',
  'trs.second.passport.font': 'Homepage',
  'trs.second.passport.hand': 'Photo with handholding',
  'trs.second.pic.font': 'Front side',
  'trs.second.pic.back': 'Back side',
  'trs.second.open.type': 'Upload',
  'trs.second.input.placeholder': 'Please enter',
  'trs.second.living.address': 'Living Address',
  'trs.second.living.address.placeholder': 'Please enter your living address',
  'trs.second.address.img': 'Proof of Address (water and electricity bills, credit card bills, etc., must state your name and address)',
  'trs.second.address.img.text': 'Upload proof',
  'trs.second.info': 'Account Statement',
  'trs.second.info.desc': 'Original asset proof with a portfolio of not less than 8 million HKD or equivalent foreign currency for the last 12 months.',
  'trs.second.info.img': 'Upload proof',
  'trs.second.upload.meterial': 'Upload Materials',
  'trs.fifth.ageGroupList1': 'Age 18-24',
  'trs.fifth.ageGroupList2': 'Age 25-34',
  'trs.fifth.ageGroupList3': 'Age 35-50',
  'trs.fifth.ageGroupList4': 'Age 51-64',
  'trs.fifth.ageGroupList5': 'Age 65 and above',
  'trs.fifth.highestEducationList1': 'Elementary School or Below',
  'trs.fifth.highestEducationList2': 'Middle School',
  'trs.fifth.highestEducationList3': 'University or Above',
  'trs.fifth.highestEducationList4': 'Professional Qualification (related to accounting/economics/finance)',
  'trs.fifth.sourcesOfFundingList1': 'Salary/Commission',
  'trs.fifth.sourcesOfFundingList2': 'Rent',
  'trs.fifth.sourcesOfFundingList3': 'Dividend/Interest',
  'trs.fifth.sourcesOfFundingList4': 'Operating Profit',
  'trs.fifth.sourcesOfFundingList5': 'Others',
  'trs.fifth.ageGroup': 'Age Group',
  'trs.fifth.please.choose': 'Please select',
  'trs.fifth.highestEducation': 'Highest Education',
  'trs.fifth.liquidAsset': 'Liquid Asset',
  'trs.fifth.netAsset': 'Net Asset Value',
  'trs.fifth.annualSalary': 'Annual Salary',
  'trs.fifth.sourcesOfFunding': 'Sources of Funding',
  'trs.fifth.finance.status': 'Financial Status',
  'trs.sixth.title': 'Risk Questionnaire',
  'trs.sixth.tip': 'Please complete the questions in the risk questionnaire first.',
  'trs.sixth.question1': '1. In terms of your average monthly household expenses, how much have you reserved for the emergency cases (including cash and liquid assets which can be easily converted into cash, for example, actively traded stock, mutual fund etc.)?',
  'trs.sixth.invest1List1': 'Less than 1-month household expenses',
  'trs.sixth.invest1List2': '1-month to less than 6-month household expenses',
  'trs.sixth.invest1List3': '6-month to less than 12-month household expenses',
  'trs.sixth.invest1List4': '12-month to less than 24-month household expenses',
  'trs.sixth.invest1List5': '24-month or more household expenses',
  'trs.sixth.invest2List1': 'Less than 1 year',
  'trs.sixth.invest2List2': '1 - 3 years',
  'trs.sixth.invest2List3': '3 - 5 years',
  'trs.sixth.invest2List4': '5 - 10 years',
  'trs.sixth.invest2List5': 'More than 10 years',
  'trs.sixth.invest3List1': 'Less than 5%',
  'trs.sixth.invest3List2': '5% to less than 10%',
  'trs.sixth.invest3List3': '10% to less than 20%',
  'trs.sixth.invest3List4': '20% to less than 30%',
  'trs.sixth.invest3List5': 'More than 30%',
  'trs.sixth.invest4List1': 'Less than 10%',
  'trs.sixth.invest4List2': '10% to less than 20%',
  'trs.sixth.invest4List3': '20% to less than 30%',
  'trs.sixth.invest4List4': '30% to less than 40%',
  'trs.sixth.invest4List5': 'More than 40%',
  'trs.sixth.invest5List1': 'Fluctuation between -5% to +5%',
  'trs.sixth.invest5List2': 'Fluctuation between -10% to +10%',
  'trs.sixth.invest5List3': 'Fluctuation between -20% to +20%',
  'trs.sixth.invest5List4': 'Fluctuation between -30% to +30%',
  'trs.sixth.invest5List5': 'Fluctuation below -30% and over 30%',
  'trs.sixth.invest6List1': 'My main investment objective is capital preservation. I aim to achieve investment returns slightly above deposit rates and I can only tolerate minimal capital loss.',
  'trs.sixth.invest6List2': 'My main investment objective isincome oriented. I aim to generate regular income returns above deposit rates or counteract inflation and I can tolerate low risk of capital loss.',
  'trs.sixth.invest6List3': 'My main investment objective is income and growth oriented. I aim to achieve returns from both capital appreciation and stable income and I can tolerate moderate risk of capital loss.',
  'trs.sixth.invest6List4': 'My main investment objective is growth oriented. I aim to achieve substantial capital growth with less emphasis on income generation and I can tolerate high risk of capital loss to achieve higher returns.',
  'trs.sixth.invest6List5': 'My main investment objective is aggressive growth. I aim to maximize capital growth and I am able to tolerate very high risk of capital loss which may exceed the initial invested value.',
  'trs.sixth.invest7List1': 'No capital loss',
  'trs.sixth.invest7List2': 'Loss up to 10%',
  'trs.sixth.invest7List3': 'Loss up to 20%',
  'trs.sixth.invest7List4': 'Loss up to 50%',
  'trs.sixth.invest7List5': 'Total loss',
  'trs.sixth.question2': '2. Which of the following is the maximum investment horizon that you feel comfortable with for your portfolio?',
  'trs.sixth.question3': '3. How much of your after-tax income would you like to set aside for savings or investments?',
  'trs.sixth.question4': '4. What is the percentage of your total net worth (excluding your self-occupied property) that is allocated for investment purpose?',
  'trs.sixth.question5': '5. What is the highest level of price fluctuation you are willing to accept for a single investment?',
  'trs.sixth.question6': '6. Which of the following best describes your general attitude towards investment return and risks?',
  'trs.sixth.question7': '7. What is your acceptable level of potential loss on the investment amount?',
  'trs.seventh.tip': 'Please complete the questions related to investment experience in the risk questionnaire first.',
  'trs.seventh.title': 'Risk Questionnaire',
  'trs.seventh.title.desc': '8. Please indicate your investment experience on the following financial products',
  'trs.seventh.investList1': 'None',
  'trs.seventh.investList2': '0-3 years',
  'trs.seventh.investList3': '4-6 years',
  'trs.seventh.investList4': '7-10 years',
  'trs.seventh.investList5': 'Over 10 years',
  'trs.seventh.question1': '(1). Stocks',
  'trs.seventh.question2': '(2). Exchange Traded Funds with different risk categories',
  'trs.seventh.question3': '(3). Non Exchange Traded Funds with different risk categories such as Mutual Funds, Unit Trust Funds, Hedge Funds, Private Equity Funds etc.',
  'trs.seventh.question4': '(4). Fixed Income Products with different risk categories (Plain Vanilla) such as Bonds',
  'trs.seventh.question5': '(5). Fixed Income Products (Complex) with features such as perpetual, convertible, callable features etc.',
  'trs.seventh.question6': '(6). Listed Derivatives / Structured Products such as Equity Options, Futures, Futures Options, Warrants etc.',
  'trs.seventh.question7': '(7). OTC Derivatives / Structured Products such as Accumulators, Decumulators etc.',
  'trs.seventh.question8': '(8). Leveraged FX Trading',
  'trs.seventh.question9': '(9). Others, please specify',
  'trs.seventh.question9.placeholder': 'optional',
  'trs.eighth.title': 'Knowledge of Derivative and Structured Products',
  'trs.eighth.question1': '1. Have you ever attended any courses or seminars on structured or derivative product(s)?',
  'trs.eighth.question1.1': 'Name of the courses/seminars is:',
  'trs.eighth.question1.2': 'Date of the courses/seminars is:',
  'trs.eighth.question2': '2. Do you have current or previous work experience related to structured or derivative products?',
  'trs.eighth.question2.1': 'Your employer’s name :',
  'trs.eighth.question2.2': 'Employment start date:',
  'trs.eighth.question3': '3. Have you executed five or more transactions in structured or derivative products within the past three years?',
  'trs.eighth.yes': 'Yes',
  'trs.eighth.no': 'No',
  'trs.ninth.title1': 'Disclaimer',
  'trs.ninth.title1.desc1': '1. The investment risk assessment result in this Questionnaire is derived from the information provided to WBroker by you through a pre-set risk assessment process and is intended to assist you to understand your investment needs and risk tolerance and is merely provided for reference only. No representation is made that any returns indicated will be achieved. Changes to the assumptions made or any information provided by you may have a material impact on the result indicated. Accordingly, WBroker accept(s) no liability whatsoever as to the completeness or accuracy of the information or result contained in this document and in respect of any consequences should you choose to rely on the information or result contained herein.',
  'trs.ninth.title1.desc2': '2. Before making any investment decisions, you should take into account your financial situation, investment experience, investment objectives and risk tolerance ability. Additionally, you should seek further consultation with investment professional(s) to more thoroughly understand the risks associated with securities investments, which include (but not limited to), market risk, political risk, credit risk, economic risk and currency risk. WBroker will not be responsible for any consequences should you choose to rely on information herein contained.',
  'trs.ninth.title1.desc3': '3. Similar to most types of investment, the returns and the value of principal may go up as well as down. As such, you may suffer substantial investment losses due to unfavourable market conditions during the course of investment. You should therefore only invest in line with own risk taking capability and circumstance. The choice of investments implied in this document is not a substitute for appropriate professional investment advice.',
  'trs.ninth.title1.desc4': '4. WBroker reserves the sole right to amend or vary the contents of this document from time to time without prior notice. In the event of any dispute, the decision of WBroker shall be final and conclusive.',
  'trs.ninth.title1.desc5': '5. The information contained in this document is provided solely for reference only and does not constitute any offer,',
  'trs.ninth.title1.desc6': '6. If you have any doubt about this document, independent professional advice should be sought.',
  'trs.ninth.title2': 'Personal Information Collection Statement',
  'trs.ninth.title2.desc': "The personal information collected will be used for any of the purposes set out above. Depending on the actual business or operational needs, the personal information collected may be transferred to (i) the administrative, operating or information technology departments of any member of the WBroker; (ii) any third party service provider to WBroker who has a legitimate need to obtain the information in connection with the provision of the relevant service to WBroker; (iii) any business partner or other financial product issuer having business relationship with WBroker who has a legitimate need to obtain the information in connection with the provision of the relevant financial product to the client; and (iv) any governmental, judicial, statutory or self-regulatory authority having competent jurisdiction over any member of WBroker. Subject to the aforesaid, the personal information held by us is kept confidential. This form will be destroyed not later than 1 year after it no longer serves any of the purposes set out herein. As part of the business records of WBroker, this form may be retained for a substantial period of time due to the need to comply with applicable laws or regulatory requirements.",
  'trs.tenth.tip1': 'Please tick the personal statement.',
  'trs.tenth.tip2': 'Please complete the signing of agreement first.',
  'trs.tenth.title1': 'Client’s Confirmation',
  'trs.tenth.title1.desc1': 'I confirm that my responses above are true, correct and accurate;',
  'trs.tenth.title1.desc2': 'I confirm that WBroker may rely on information provided by me to determine my risk profiles and the type of investment products that would be suitable for me;',
  'trs.tenth.title1.desc3': "I agree to inform WBroker in writing on any change in any information provided in this Questionnaire and I understand that WBroker will continue to rely on the information provided in the most recent Risk Questionnaire on WBroker's records until WBroker has received an updated version from me;",
  'trs.tenth.title1.desc4': 'I confirm that the answers to this Questionnaire have been provided according to the instructions, and that the answers may be relied on by VCL/ VAMLin assessing the suitability of investment products for theAccount, notwithstanding that other account holders of the Account may individually have different investment knowledge and experience, risk, capacity, risk tolerance, financial situation and investment objectives;',
  'trs.tenth.title1.desc5': 'I have also read, understood and agreed with all the details stated in this Questionnaire;',
  'trs.tenth.title1.desc6': "I understand that any inaccurate or incomplete information that I provide or have provided may affect WBroker's suitability assessment of the investment products and services to be offered to me; ",
  'trs.tenth.title1.desc7': 'andI understand and accept that WBroker doeso not make any final investment decisions for me, and that I am responsible for my own investment decision, including whether a product or service ultimately meets my personal needs or circumstances.',
  'trs.tenth.title2': 'Agreement Signing',
  'trs.tenth.title2.desc': 'I have read and agree to sign following agreements',
  'trs.result.desc': 'Your information has been submitted for review and is expected to be completed within 1-2 business days.',
  'trs.result.back.homePage': 'Homepage',
  'update.info.checking': '您已提交账户信息，请耐心等待审核！',

  'trust.fixedAmountLimit.label': 'Amount of subscription',
  'trust.fixedAmountLimit.label.placeholder': 'Please enter the amount',
  'trust.purchurs.amount.label': 'Number of shares',
  'trust.intrustCode.label': 'Invitation Code',
  'trust.intrustCode.placeholder': 'Please enter invitation code',
  'trust.password.label': 'Transaction PIN',
  'trust.password.placeholder': 'Please enter transaction PIN',
  'trust.sell.label': 'Amount of redemption',
  'intrust.title': 'Trust Details',
  'intrust.his.tab.title': 'Historical value',
  'intrust.his.amount.shares': 'shares',

  'menu.report.detail': 'Detail',

  'ipo.header.title': 'Detail',
  'ipo.subscription.header.title': 'Subscription',
  'IpoResult.header.title': 'Subscription',
  'ipo.per.amount': 'Investment Amount per Share',
  'ipo.amount.placeholder': 'Please enter the subscription amount',
  'trs.asset.cashValue': 'Cash Available:',
  'ipo.limit': '*Limited to ',
  'ipo.limit1': ' purchases',
  'ipo.tip': '*Subscription may fail between 16:00-20:00 on trading days due to system settlement',
  'ipo.contract1': 'I have read and agree to electronically sign the ',
  'ipo.contract2': 'agreement',
  'ipo.time': 'Subscription Time',
  'ipo.product': 'Product',
  'ipo.sucess': 'Subscription Successful',
  'ipo.error170014': 'Invalid subscription code',
  'ipo.error171000': 'Invalid subscription quantity',
  'ipo.error171001': 'Subscription quantity exceeds personal limit',
  'ipo.error171002': 'Sold out',
  'ipo.error171003': 'Can not redeem at the moment',

  'raffle.index.title': 'New Year Lucky Draw',
  'update.man': 'man',
  'update.woman': 'woman',
  'update.sex': 'Sex',
  'account.bank.no.label': 'Bank Card Number',
  'account.bank.no.placeholder': 'Please enter the mainland China UnionPay bank card number',
  'account.bank.account.name.label': 'Name of Bank Account Holder',
  'account.bank.account.mobile.label': 'Mobile Number',
  'account.bank.account.mobile.placeholder': 'Please enter the mobile number associated with your bank account',
  'account.ca.tips1': '1. In accordance with regulatory requirements, you need to complete the account opening process and provide relevant information to determine if you meet the requirements as an investor before investing.',
  'account.ca.tips2': '2. Waton International will strictly protect your information.',
  'account.ca.tips3': '3. This bank card is only used for identity verification.',
  'ca.error.tip': 'CA certification failed: ',
  'ca.menu.title': 'Identity Authentication',
  'ca.index.btn': 'Start Authentication',
  'ca.upload.tip1': '1. Waton International will strictly protect your information.',
  'ca.upload.tip2': '2. The ID information is only used for identity authentication.',
  'agreement.error.tip': 'Please check the agreement box first',
  'ca.index.title': 'To ensure the safety of your assets, please complete the identity authentication process',
  'ca.index.tip1': 'Please make sure the environment is quiet and well-lit.',
  'ca.index.tip2': 'Please prepare your mainland China UnionPay bank card in advance.',
  'ca.index.agreement1': 'The identity authentication service is provided by GDCA. I have read and agreed to the ',
  'ca.index.agreement2': 'GDCA Digital Certificate User Agreement',
  'ca.index.agreement3': ' and ',
  'ca.index.agreement4': 'Application for Digital Certificate Related Terms',
  'account.market.title': 'Please confirm the type of account you wish to open',
  'account.market.error': 'please confirm the type',
  'account.market.type1': 'Margin Account',
  'account.market.type1.desc': 'Margin account allows trading with own cash, and also the option to borrow funds for trading',
  'account.market.type2': 'Cash Account',
  'account.market.type2.desc': 'Cash Account only permits trading with own cash; it does not allow borrowing or financing transactions.',
  'account.market.type.title': 'Please confirm the market types you wish to trade in',
  'account.market.type.error': 'Please confirm the market',
  'account.market.type.HK': 'HK Stocks',
  'account.market.type.US': 'US Stocks',
  'account.market.type.CN': 'Mainland China Stocks',
  'open.end.tips1': 'Your verification information has been submitted',
  'open.end.tips2': 'Estimated completion within 1 working day',

  'update.place.of.birth': 'Place of Birth',
  'update.residence': 'Residence',
  'form.account.valuation2': 'Valuation (net of mortgage)',
  'account.open.form.work.unemployed': 'Unemployed',

  'account.open.bank.name': 'Bank Name',

  'account.open.asset.status20': '< 200,000',
  'account.open.asset.status2050': '200,000-500,000',
  'account.open.asset.status50100': '500,000-1,000,000',
  'account.open.asset.status100500': '1,000,000-5,000,000',
  'account.open.asset.status5001000': '5,000,000-10,000,000',
  'account.open.asset.status.1000+': '>10,000,000',
  'account.open.asset.status.Negative.equity': 'negative asset',
  'account.open.asset.year.status20': '< 200,000',
  'account.open.asset.year.status2050': '200,000-500,000',
  'account.open.asset.year.status50100': '500,000-1,000,000',
  'account.open.asset.year.status100500': '1,000,000-5,000,000',
  'account.open.asset.year.status5001000': '5,000,000-10,000,000',
  'account.open.asset.year.status.1000+': '>10,000,000',
  'account.open.questionnaire.source.type1': 'Savings',
  'account.open.questionnaire.source.type2': 'Salary Income',
  'account.open.questionnaire.source.type3': 'Rent',
  'account.open.questionnaire.source.type4': 'Family Inheritance',
  'account.open.questionnaire.source.type5': 'Entrepreneurship',
  'account.open.questionnaire.source.type6': 'Investment Income',
  'account.open.questionnaire.source.type7': 'Other',
  'account.open.questionnaire.objective.type1': 'Capital Investment',
  'account.open.questionnaire.objective.type2': 'Hedge',
  'account.open.questionnaire.objective.type3': 'Speculation',
  'account.open.questionnaire.objective.type4': 'Dividend/Interest Income',
  'account.open.questionnaire.title1': 'Employment',
  'account.open.questionnaire.title2': 'Company Name',
  'account.open.questionnaire.title3': 'Profession/Position',
  'account.open.questionnaire.title4': 'Tenure of Office',
  'account.open.questionnaire.title5': 'Position',
  'account.open.questionnaire.title6': 'Education',
  'account.open.questionnaire.title7': 'Income',
  'account.open.questionnaire.title8': 'Net Assets',
  'account.open.questionnaire.title9': 'Source of Wealth (Multiple Choice) ',
  'account.open.questionnaire.title10': 'Source of Trading Funds (Multiple Choice)',
  'account.open.questionnaire.title11': 'Investment Objectives',
  'account.open.questionnaire.title12': 'Investment Experience',
  'account.open.questionnaire.title13': 'Investment Leverage',
  'account.open.questionnaire.title14': 'Investment in Precious Metals',
  'account.open.questionnaire.title15': 'Investment in Options',
  'account.open.questionnaire.title16': 'Derivatives Knowledge',
  'account.open.questionnaire.title17': 'Risk Tolerance',
  'account.open.questionnaire.title18': 'Net Assets (HKD)',
  'account.open.questionnaire.title19': 'Excluding property, car, furniture, personal items, and life insurance',
  'account.open.questionnaire.title20': 'Investment in Stocks, Bonds, and Other Securities',
  'account.open.questionnaire.title21': 'Investment in Leveraged Foreign Exchange',
  'account.open.questionnaire.title22': 'Investment in Precious Metals',
  'account.open.questionnaire.title23': 'Investment in Futures/Options',
  'account.open.questionnaire.title24': 'Understanding of Derivatives',
  'account.open.questionnaire.title25': 'Annual Income (HKD)',

  'account.open.bank.check.tips': 'Please use a Mainland China bank card identical to the account holder’s name for identity verification to comply with CSRC regulations',
  'account.open.License.Number': 'License Number',
  'account.open.bank.check.UnionPay.bank': 'Please enter the name of a Mainland China UnionPay bank',

  'account.open.bank.check.11': 'Mobile phone number is limited to 11 digits',

  'account.open.derivative.title': 'How to acquire the relevant knowledge of derivatives',
  'account.open.derivative.1': 'At least 5 transactions of any derivatives products in the past three years',
  'account.open.derivative.2': 'Attended any courses or seminars on structured or derivative product(s)',
  'account.open.derivative.3': 'Work experience involved in derivatives',
  'account.open.derivative.4': 'Name of the courses/seminars',
  'account.open.derivative.5': 'Date of the courses/seminars',
  'account.open.search.tips': 'Country/Region',

  'margin.tips': 'You need to consider your investment goal and risk tolerance before investing in financial products with potential risk.',
  'margin.end': 'Account has been upgraded',
  'margin.agreement.tips': 'I have carefully read and agreed to sign',
  'margin.agreement.tips2': ' Account Upgrade Authorization ',
}
